module.exports = __webpack_public_path__ + "img/beenhere.569c6d1c.svg";